import { memo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { Typography } from '@s_mart/core';
import { TextField } from '@s_mart/form';
import { valor } from '@s_mart/masks';
import { colorPalette } from '@s_mart/tokens';
import { ellipsis } from '@s_mart/utils';

import { useIsAdmin } from 'hooks/useIsAdmin/useIsAdmin';

import { useFields } from '../../useFields';

const FieldValorVendaInversores = ({ index }: { index: number }) => {
  const methods = useFormContext();
  const { handleCalcularValorTotal } = useFields();
  const isAdmin = useIsAdmin();

  const _formValuesInversores = methods.watch('inversores');

  useEffect(() => {
    handleCalcularValorTotal({ values: methods.getValues(), methods });
  }, [_formValuesInversores?.[index || 0]?.valorVendaInversores]);

  const value = methods.watch(`inversores.${index}.valorVendaInversores`);

  return (
    <TextField
      name={`inversores.${index}.valorVendaInversores`}
      label='Valor de venda'
      value={value ? valor.format(value) : undefined}
      helperText={
        <Typography variant='bodyXS' color={colorPalette.neutral[100]}>
          {ellipsis(
            `Total: ${valor.format(
              (_formValuesInversores?.[index || 0]?.valorVendaInversores || 0) *
                (_formValuesInversores?.[index || 0]?.quantidadeInversores || 0)
            )}`,
            19
          )}
        </Typography>
      }
      mask='valor'
      placeholder='R$ 0,00'
      disabled={!isAdmin}
    />
  );
};

export default memo(FieldValorVendaInversores);
